/**
 * Merges IHS + PMS per language for a single lookup table consumed by `TranslationProvider` / `useTranslations`.
 * Source bundles: `ihsTranslations.ts` and `pmsTranslations.ts` (JSON under `files/ihs/` and `files/pms/`).
 *
 * At runtime both widgets read the same merged object via `TranslationProvider` / `useTranslations`.
 */

import { ihsLocale } from './ihsTranslations';
import { pmsLocale } from './pmsTranslations';

const da_DK = { ...ihsLocale.da_DK };
const en_GB = { ...ihsLocale.en_GB, ...pmsLocale.en_GB };
const en_GB_long = { ...ihsLocale.en_GB_long, ...pmsLocale.en_GB_long };
const en_IE = { ...pmsLocale.en_IE };
const et_EE = { ...ihsLocale.et_EE, ...pmsLocale.et_EE };
const fr_FR = { ...ihsLocale.fr_FR };
const ro_RO = { ...ihsLocale.ro_RO, ...pmsLocale.ro_RO };

export const locale = {
  da_DK,
  en_GB,
  en_GB_long,
  en_IE,
  et_EE,
  fr_FR,
  ro_RO,
};

export { locale_en_main_menu_names } from './ihsTranslations';

export default locale;
